import { useQuery } from "@tanstack/react-query";
import { fetchModerators } from "../services/moderators";
import { ModeratorOrderingField } from "../types/api/moderators";

export const useModeratorsQuery = (
  search: string = "",
  page: number,
  limit: number,
  ordering?: ModeratorOrderingField
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["moderators", search, page, limit, ordering],
    queryFn: () =>
      fetchModerators({
        search: search || undefined,
        limit,
        offset: (page - 1) * limit,
        ordering,
      }),
    retry: 0,
  });
};
